



























import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'
import { CURRENT_USER } from '@/gql/auth'
import { MY_USER } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRouterLink
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    }
  }
})
export default class extends Mixins(Common) {
  currentUser = null
  myUser = {}
  @Prop(Number) readonly rank!: number
  @Prop(Object) readonly item!: {
    price: number;
    orgPrice: number;
  }

  get discountRate () {
    if (!this.item.orgPrice) return undefined
    return Math.round((this.item.orgPrice - this.item.price) * 100 / this.item.orgPrice)
  }
}
